module.exports = __webpack_public_path__ + "img/home_collections_ru.d2eba5e.png";